import React from "react";

import BaseIcon from "../BaseIcon";

const DartyLogo = props => (
  <BaseIcon viewBox="0 0 914.647 914.644" {...props}>
    <defs>
      <clipPath id="darty-logo-clip-path" clipPathUnits="userSpaceOnUse">
        <path d="M0 685.983h685.985V0H0z" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#darty-logo-clip-path)"
      transform="matrix(1.33333 0 0 -1.33333 0 914.644)"
    >
      <path
        d="M679.745 342.992c0-185.984-150.769-336.757-336.754-336.757-185.988 0-336.756 150.773-336.756 336.757 0 185.979 150.768 336.753 336.756 336.753 185.985 0 336.754-150.774 336.754-336.753"
        fill="#fff"
      />
      <path
        d="M-.079-.078h686.144v686.14H-.079zm342.18 14.16c-181.536 0-328.707 147.41-328.707 329.246 0 181.836 147.171 329.245 328.707 329.245 181.528 0 328.7-147.409 328.7-329.245S523.629 14.082 342.101 14.082"
        fill="#ed1c24"
      />
      <path
        d="M105.147 431.127H41.718s5.398-37.622 5.398-87.334c0-49.719-5.398-87.008-5.398-87.008h63.43c21.256 0 57.694 14.108 57.694 87.008 0 72.892-36.102 87.334-57.695 87.334M92.664 291.719v104.472s24.627 5.712 24.627-52.398c0-58.118-24.627-52.074-24.627-52.074M303.531 256.787s-14.17 45.351-22.606 87.003c-8.425 41.611-12.819 87.34-12.819 87.34h-80.298s-4.382-45.694-12.817-87.34c-8.437-41.652-22.269-87.003-22.269-87.003h56.004s-2.022 7.727 0 22.838c2.027 15.117 5.734 22.848 5.734 22.848h26.997s4.382-8.74 5.731-23.18c1.392-14.896 0-22.506 0-22.506zm-86.37 80.62l10.797 58.784 10.796-58.785z"
        fill="#231f20"
      />
      <path
        d="M430.053 256.787s-9.798 21.283-22.942 43.668c-12.82 21.834-20.246 32.92-20.246 32.92s30.368 9.07 30.368 48.708c0 40.534-29.694 49.046-40.821 49.046H298.47s5.062-31.912 5.062-87.339c0-55.429-5.738-87.003-5.738-87.003h57.023s-3.376 10.416-5.401 29.225c-2.025 18.81 0 29.896 0 29.896s8.098-10.748 14.17-29.562c6.074-18.807 5.06-29.559 5.06-29.559zm-80.637 99.431v45.35s19.23.331 19.23-22.507c0-22.843-19.23-22.843-19.23-22.843"
        fill="#231f20"
      />
      <path
        d="M414.535 431.127V391.15s10.453 5.041 30.025 5.041c0 0 1.67-31.527 0-61.473-1.688-30.232-5.4-77.933-5.4-77.933h56.006s-3.712 48.038-5.058 77.933c-1.352 29.899 0 61.473 0 61.473s14.844.673 29.35-5.041v39.977z"
        fill="#231f20"
      />
      <path
        d="M568.04 431.127h-50.943s22.606-42.999 32.385-87.334c9.786-44.348 4.055-87.008 4.055-87.008h56.338s-6.073 42.997 3.712 87.008c9.786 44.002 32.728 87.334 32.728 87.334h-50.942l-13.835-50.726z"
        fill="#231f20"
      />
    </g>
  </BaseIcon>
);

export default DartyLogo;
